import { render, staticRenderFns } from "./threeYearBar.vue?vue&type=template&id=4589cc97&scoped=true&"
import script from "./threeYearBar.vue?vue&type=script&lang=js&"
export * from "./threeYearBar.vue?vue&type=script&lang=js&"
import style0 from "./threeYearBar.vue?vue&type=style&index=0&id=4589cc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4589cc97",
  null
  
)

export default component.exports